import React from "react";
import withStyles from "elevate-ui/withStyles";

type Props = {
  title: string,
};

const FormSectionHeading = ({ classes, title }: Props) => {
  if (!title) {
    return null;
  }

  return (
    <div className={classes.root}>
      <span className={classes.title}>{title}</span>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    fontWeight: "700",
    fontSize: "14px",
    color: theme.colors.gray["500"],
    margin: "48px auto 24px",

    "&:before, &:after": {
      content: "''",
      display: "block",
      background: "#e0e0e0",
      width: "100%",
      height: "2px",
      margin: "0",
    },

    "&:before": {
      marginRight: theme.spacing.unit * 0.75,
    },

    "&:after": {
      marginLeft: theme.spacing.unit * 0.75,
    },
  },
  title: {
    flexShrink: "0",
    textAlign: "center",
    padding: "0 8px",
    color: theme.colors.gray["600"],
  },
}))(FormSectionHeading);
